import { get, put,Delete,post } from '../axios'

// 用户购买记录-列表
export const recordList = params => get(`/web/service/record/list`,params);


